import { Component, inject, Input, OnInit } from '@angular/core';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import { IProduct } from '../../../../../IProduct';
import { FunctionEnSavoirPlusModalComponent } from '../../../../../../../../components/ecosystems/function-en-savoir-plus-modal/function-en-savoir-plus-modal.component';
import { getTemperatureType } from '../../../../../../helper/temperature';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P0003600 } from '../../../../P0003600';
import { P0003601 } from '../../../../P0003601';
import { P0004700 } from '../../../../P0004700';
import { P00046 } from '../../../../P00046';
import { P00032 } from '../../../../P00032';
import { P00058 } from '../../../../P00058';
import { P0006600 } from '../../../../P0006600';
import { TwoChoicesModalComponent } from '../../../../../../../../components/ecosystems/two-choices-modal/two-choices-modal.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { AffichageWarningComponent } from '../../../../../../../../components/ecosystems/affichage-warning/affichage-warning.component';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { InformationTitleComponent } from '../../../../../../../../components/ecosystems/information-title/information-title.component';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { LargedLinkComponent } from '../../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { SwitchConfigurationComponent } from '../../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import { P00037TemperatureHivernage } from '../../../Enum/P00037TemperatureHivernage';

@Component({
  selector: 'app-p00037-electrolyseur-mise-en-oeuvre-protection',
  templateUrl:
    './p00037-electrolyseur-mise-en-oeuvre-protection.component.html',
  styleUrls: [
    './p00037-electrolyseur-mise-en-oeuvre-protection.component.scss',
  ],
  imports: [
    AffichageWarningComponent,
    HeaderConfigurationComponent,
    InformationTitleComponent,
    IonButton,
    IonContent,
    LabelConfigurationComponent,
    LabelDescriptionComponent,
    LargedLinkComponent,
    SwitchConfigurationComponent,
    TranslatePipe,
  ],
})
export class P00037ElectrolyseurMiseEnOeuvreProtectionComponent
  implements OnInit
{
  private modalController: ModalController = inject(ModalController);
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private slideModalController: SlideModalController =
    inject(SlideModalController);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  @Input() pool: Pool | null = null;

  constructor() {
    this.EnSavoirPlusPage = this.EnSavoirPlusPage.bind(this);
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  async EnSavoirPlusPage() {
    const modal = await this.slideModalController.create({
      component: FunctionEnSavoirPlusModalComponent,
      componentProps: {
        description: 'P00037.reglage.hivernageESP.' + getTemperatureType(),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  hasProduitP0003600() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P0003600()) ?? 0;
  }

  hasProduitP0003601() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P0003601()) ?? 0;
  }

  hasProduitP0004700() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P0004700()) ?? 0;
  }

  hasProduitP00046() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00046()) ?? 0;
  }

  hasProduitP00058() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00058()) ?? 0;
  }

  hasProduitP0006600() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P0006600()) ?? 0;
  }

  hasProduitP00032() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    let res = master?.hasProduct(p!, new P00032()) ?? 0;

    if (
      this.actionStack!.getValue(
        'snIInstallationCapteurDebit',
        new P00032(),
      ) !== 1
    ) {
      res = 0;
    }

    return res;
  }

  showPositionModal() {
    return (
      this.hasProduitP00032() > 0 &&
      (this.hasProduitP0003600() > 0 ||
        this.hasProduitP0004700() > 0 ||
        this.hasProduitP0003601() > 0 ||
        this.hasProduitP00046() > 0 ||
        this.hasProduitP00058() > 0 ||
        this.hasProduitP0006600() > 0)
    );
  }

  async openPositionModal() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p!);

    const produitP0003600 = master?.hasProduct(p!, new P0003600()) ?? 0;
    const produitP0004700 = master?.hasProduct(p!, new P0004700()) ?? 0;
    const produitP00046 = master?.hasProduct(p!, new P00046()) ?? 0;
    const produitP0003601 = master?.hasProduct(p!, new P0003601()) ?? 0;
    const produitP00058 = master?.hasProduct(p!, new P00058()) ?? 0;
    const produitP0006600 = master?.hasProduct(p!, new P0006600()) ?? 0;

    let produitP00032 = master?.hasProduct(p!, new P00032()) ?? 0;
    if (
      this.actionStack!.getValue(
        'snIInstallationCapteurDebit',
        new P00032(),
      ) !== 1
    ) {
      produitP00032 = 0;
    }

    const getSourceDebit = (
      PP00046: any,
      PP0003601: any,
      PP00032: any,
      PP0003600: any,
      PP0004700: any,
      PP00058: any,
      PP0006600: any,
      injection: any,
      detecteur: any,
    ) => {
      if (
        PP00046 === 0 &&
        PP0003601 === 0 &&
        PP00032 > 0 &&
        (PP0003600 > 0 || PP0004700 > 0) &&
        PP00058 === 0 &&
        PP0006600 === 0 &&
        injection === 0 &&
        detecteur === 0
      ) {
        return { default: 1, choixUser: [1, 2] };
      }
      if (
        PP00046 === 0 &&
        PP0003601 === 0 &&
        PP00032 > 0 &&
        (PP0003600 > 0 || PP0004700 > 0) &&
        PP00058 === 0 &&
        PP0006600 === 0 &&
        injection === 0 &&
        detecteur === 1
      ) {
        return { default: 2, choixUser: [1, 2] };
      }
      if (
        PP00046 === 0 &&
        PP0003601 === 0 &&
        PP00032 > 0 &&
        (PP0003600 > 0 || PP0004700 > 0) &&
        PP00058 === 0 &&
        PP0006600 === 0 &&
        injection === 1 &&
        detecteur === 0
      ) {
        return { default: 3, choixUser: [1, 2] };
      }
      if (
        PP00046 === 0 &&
        PP0003601 === 0 &&
        PP00032 > 0 &&
        (PP0003600 > 0 || PP0004700 > 0) &&
        PP00058 === 0 &&
        PP0006600 === 0 &&
        injection === 1 &&
        detecteur === 1
      ) {
        return { default: 4, choixUser: [1, 2] };
      }

      if (
        (PP00046 > 0 || PP0003601 > 0) &&
        PP00032 > 0 &&
        PP0003600 === 0 &&
        PP0004700 === 0 &&
        PP00058 === 0 &&
        PP0006600 === 0 &&
        injection === 0 &&
        detecteur === 0
      ) {
        return { default: 1, choixUser: [1, 3] };
      }
      if (
        (PP00046 > 0 || PP0003601 > 0) &&
        PP00032 > 0 &&
        PP0003600 === 0 &&
        PP0004700 === 0 &&
        PP00058 === 0 &&
        PP0006600 === 0 &&
        injection === 0 &&
        detecteur === 1
      ) {
        return { default: 2, choixUser: [1, 3] };
      }
      if (
        (PP00046 > 0 || PP0003601 > 0) &&
        PP00032 > 0 &&
        PP0003600 === 0 &&
        PP0004700 === 0 &&
        PP00058 === 0 &&
        PP0006600 === 0 &&
        injection === 1 &&
        detecteur === 0
      ) {
        return { default: 3, choixUser: [1, 3] };
      }
      if (
        (PP00046 > 0 || PP0003601 > 0) &&
        PP00032 > 0 &&
        PP0003600 === 0 &&
        PP0004700 === 0 &&
        PP00058 === 0 &&
        PP0006600 === 0 &&
        injection === 1 &&
        detecteur === 1
      ) {
        return { default: 4, choixUser: [1, 3] };
      }

      if (
        (PP00046 > 0 || PP0003601 > 0) &&
        PP00032 > 0 &&
        (PP0003600 > 0 || PP0004700 > 0) &&
        PP00058 === 0 &&
        PP0006600 === 0 &&
        injection === 0 &&
        detecteur === 0
      ) {
        return { default: 1, choixUser: [1, 2] };
      }
      if (
        (PP00046 > 0 || PP0003601 > 0) &&
        PP00032 > 0 &&
        (PP0003600 > 0 || PP0004700 > 0) &&
        PP00058 === 0 &&
        PP0006600 === 0 &&
        injection === 0 &&
        detecteur === 1
      ) {
        return { default: 2, choixUser: [1, 2] };
      }
      if (
        (PP00046 > 0 || PP0003601 > 0) &&
        PP00032 > 0 &&
        (PP0003600 > 0 || PP0004700 > 0) &&
        PP00058 === 0 &&
        PP0006600 === 0 &&
        injection === 1 &&
        detecteur === 0
      ) {
        return { default: 3, choixUser: [1, 2] };
      }
      if (
        (PP00046 > 0 || PP0003601 > 0) &&
        PP00032 > 0 &&
        (PP0003600 > 0 || PP0004700 > 0) &&
        PP00058 === 0 &&
        PP0006600 === 0 &&
        injection === 1 &&
        detecteur === 1
      ) {
        return { default: 4, choixUser: [1, 2] };
      }

      if (
        PP00046 === 0 &&
        PP0003601 === 0 &&
        PP00032 > 0 &&
        PP0003600 === 0 &&
        PP0004700 === 0 &&
        (PP00058 > 0 || PP0006600 > 0) &&
        injection === 0 &&
        detecteur === 0
      ) {
        return { default: 1, choixUser: [1, 4] };
      }
      if (
        PP00046 === 0 &&
        PP0003601 === 0 &&
        PP00032 > 0 &&
        PP0003600 === 0 &&
        PP0004700 === 0 &&
        (PP00058 > 0 || PP0006600 > 0) &&
        injection === 0 &&
        detecteur === 1
      ) {
        return { default: 2, choixUser: [1, 4] };
      }
      if (
        PP00046 === 0 &&
        PP0003601 === 0 &&
        PP00032 > 0 &&
        PP0003600 === 0 &&
        PP0004700 === 0 &&
        (PP00058 > 0 || PP0006600 > 0) &&
        injection === 1 &&
        detecteur === 0
      ) {
        return { default: 3, choixUser: [1, 4] };
      }
      if (
        PP00046 === 0 &&
        PP0003601 === 0 &&
        PP00032 > 0 &&
        PP0003600 === 0 &&
        PP0004700 === 0 &&
        (PP00058 > 0 || PP0006600 > 0) &&
        injection === 1 &&
        detecteur === 1
      ) {
        return { default: 4, choixUser: [1, 4] };
      }

      if (
        PP00046 === 0 &&
        PP0003601 === 0 &&
        PP00032 > 0 &&
        (PP0003600 > 0 || PP0004700 > 0) &&
        (PP00058 > 0 || PP0006600 > 0) &&
        injection === 0 &&
        detecteur === 0
      ) {
        return { default: 1, choixUser: [1, 2] };
      }
      if (
        PP00046 === 0 &&
        PP0003601 === 0 &&
        PP00032 > 0 &&
        (PP0003600 > 0 || PP0004700 > 0) &&
        (PP00058 > 0 || PP0006600 > 0) &&
        injection === 0 &&
        detecteur === 1
      ) {
        return { default: 2, choixUser: [1, 2] };
      }
      if (
        PP00046 === 0 &&
        PP0003601 === 0 &&
        PP00032 > 0 &&
        (PP0003600 > 0 || PP0004700 > 0) &&
        (PP00058 > 0 || PP0006600 > 0) &&
        injection === 1 &&
        detecteur === 0
      ) {
        return { default: 3, choixUser: [1, 2] };
      }
      if (
        PP00046 === 0 &&
        PP0003601 === 0 &&
        PP00032 > 0 &&
        (PP0003600 > 0 || PP0004700 > 0) &&
        (PP00058 > 0 || PP0006600 > 0) &&
        injection === 1 &&
        detecteur === 1
      ) {
        return { default: 4, choixUser: [1, 2] };
      }

      if (
        (PP00046 > 0 || PP0003601 > 0) &&
        PP00032 > 0 &&
        PP0003600 === 0 &&
        PP0004700 === 0 &&
        (PP00058 > 0 || PP0006600 > 0) &&
        injection === 0 &&
        detecteur === 0
      ) {
        return { default: 1, choixUser: [1, 3] };
      }
      if (
        (PP00046 > 0 || PP0003601 > 0) &&
        PP00032 > 0 &&
        PP0003600 === 0 &&
        PP0004700 === 0 &&
        (PP00058 > 0 || PP0006600 > 0) &&
        injection === 0 &&
        detecteur === 1
      ) {
        return { default: 2, choixUser: [1, 3] };
      }
      if (
        (PP00046 > 0 || PP0003601 > 0) &&
        PP00032 > 0 &&
        PP0003600 === 0 &&
        PP0004700 === 0 &&
        (PP00058 > 0 || PP0006600 > 0) &&
        injection === 1 &&
        detecteur === 0
      ) {
        return { default: 3, choixUser: [1, 3] };
      }
      if (
        (PP00046 > 0 || PP0003601 > 0) &&
        PP00032 > 0 &&
        PP0003600 === 0 &&
        PP0004700 === 0 &&
        (PP00058 > 0 || PP0006600 > 0) &&
        injection === 1 &&
        detecteur === 1
      ) {
        return { default: 4, choixUser: [1, 3] };
      }

      if (
        (PP00046 > 0 || PP0003601 > 0) &&
        PP00032 > 0 &&
        (PP0003600 > 0 || PP0004700 > 0) &&
        (PP00058 > 0 || PP0006600 > 0) &&
        injection === 0 &&
        detecteur === 0
      ) {
        return { default: 1, choixUser: [1, 2] };
      }
      if (
        (PP00046 > 0 || PP0003601 > 0) &&
        PP00032 > 0 &&
        (PP0003600 > 0 || PP0004700 > 0) &&
        (PP00058 > 0 || PP0006600 > 0) &&
        injection === 0 &&
        detecteur === 1
      ) {
        return { default: 2, choixUser: [1, 2] };
      }
      if (
        (PP00046 > 0 || PP0003601 > 0) &&
        PP00032 > 0 &&
        (PP0003600 > 0 || PP0004700 > 0) &&
        (PP00058 > 0 || PP0006600 > 0) &&
        injection === 1 &&
        detecteur === 0
      ) {
        return { default: 3, choixUser: [1, 2] };
      }
      if (
        (PP00046 > 0 || PP0003601 > 0) &&
        PP00032 > 0 &&
        (PP0003600 > 0 || PP0004700 > 0) &&
        (PP00058 > 0 || PP0006600 > 0) &&
        injection === 1 &&
        detecteur === 1
      ) {
        return { default: 4, choixUser: [1, 2] };
      }

      return null;
    };

    const sourceReferenceDebit = getSourceDebit(
      produitP00046,
      produitP0003601,
      produitP00032,
      produitP0003600,
      produitP0004700,
      produitP00058,
      produitP0006600,
      this.poolAdditionalData!.positionCelluleSalt ?? 0,
      this.poolAdditionalData!.positionDetecteurDebit ?? 0,
    );

    let componentProps = {};

    if (sourceReferenceDebit && sourceReferenceDebit.default === 1) {
      componentProps = {
        title: 'P00037.modal.sourcereferencedebit.page1.title',
        value: this.actionStack!.getValue(
          'elISourceReferenceDebitFonctionProtectionDebit',
        ),
        firstChoice: {
          title: 'P00037.modal.sourcereferencedebit.page1.option0',
          image:
            '/assets/ecosystem/images/products/P00037/P00037-sourcedebit-0-0.png',
          value: sourceReferenceDebit.choixUser[0],
        },
        secondChoice: {
          title: 'P00037.modal.sourcereferencedebit.page1.option1',
          image:
            '/assets/ecosystem/images/products/P00037/P00037-sourcedebit-0-1.png',
          value: sourceReferenceDebit.choixUser[1],
        },
      };
    } else if (sourceReferenceDebit && sourceReferenceDebit.default === 2) {
      componentProps = {
        title: 'P00037.modal.sourcereferencedebit.page2.title',
        value: this.actionStack!.getValue(
          'elISourceReferenceDebitFonctionProtectionDebit',
        ),
        firstChoice: {
          title: 'P00037.modal.sourcereferencedebit.page2.option0',
          image:
            '/assets/ecosystem/images/products/P00037/P00037-sourcedebit-1-0.png',
          value: sourceReferenceDebit.choixUser[0],
        },
        secondChoice: {
          title: 'P00037.modal.sourcereferencedebit.page2.option1',
          image:
            '/assets/ecosystem/images/products/P00037/P00037-sourcedebit-1-1.png',
          value: sourceReferenceDebit.choixUser[1],
        },
      };
    } else if (sourceReferenceDebit && sourceReferenceDebit.default === 3) {
      componentProps = {
        title: 'P00037.modal.sourcereferencedebit.page3.title',
        value: this.actionStack!.getValue(
          'elISourceReferenceDebitFonctionProtectionDebit',
        ),
        firstChoice: {
          title: 'P00037.modal.sourcereferencedebit.page3.option0',
          image:
            '/assets/ecosystem/images/products/P00037/P00037-sourcedebit-2-0.png',
          value: sourceReferenceDebit.choixUser[0],
        },
        secondChoice: {
          title: 'P00037.modal.sourcereferencedebit.page3.option1',
          image:
            '/assets/ecosystem/images/products/P00037/P00037-sourcedebit-2-1.png',
          value: sourceReferenceDebit.choixUser[1],
        },
      };
    } else if (sourceReferenceDebit && sourceReferenceDebit.default === 4) {
      componentProps = {
        title: 'P00037.modal.sourcereferencedebit.page4.title',
        value: this.actionStack!.getValue(
          'elISourceReferenceDebitFonctionProtectionDebit',
        ),
        firstChoice: {
          title: 'P00037.modal.sourcereferencedebit.page4.option0',
          image:
            '/assets/ecosystem/images/products/P00037/P00037-sourcedebit-3-0.png',
          value: sourceReferenceDebit.choixUser[0],
        },
        secondChoice: {
          title: 'P00037.modal.sourcereferencedebit.page4.option1',
          image:
            '/assets/ecosystem/images/products/P00037/P00037-sourcedebit-3-1.png',
          value: sourceReferenceDebit.choixUser[1],
        },
      };
    }

    const modal = await this.modalController.create({
      component: TwoChoicesModalComponent,
      componentProps: componentProps,
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();

    if (data) {
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Installation,
        'elISourceReferenceDebitFonctionProtectionDebit',
        data.value,
        null,
      );
    }
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00037TemperatureHivernage = P00037TemperatureHivernage;
}
